











import traceQuery from '~/queries/trace-region.gql'
import { clearAllBodyScrollLocks } from 'body-scroll-lock'

export default

	props:
		region: Object

	data: ->
		loaded: false
		regionData: {}

	fetch: ->
		@regionData = await @$craft.execute
			query: traceQuery
			variables:
				region: @country

		@loaded = true

	computed:

		country: -> switch @region.COOCountry
			when "United States" then 'california'
			when "Chile" then 'chile'
			when "Portugal" then 'portugal'
			when "Argentina" then 'argentina'
			when "Tunisia" then 'tunisia'
			when "Spain" then 'spain'

		# shorthand
		currentRegion: -> @regionData?.category

		block: -> {
			id: @currentRegion?.id
			backgroundColor: '#FFFFFF'
			buttons: []
			customTitle: null
			componentName: 'blocks-half-marquee'
			foregroundImage: []
			icon: []
			image: @currentRegion?.image
			layout: 'left'
			showLines: false
			video: null
			videoLabel: null
			videoUrl: null
			table: {}
			copy: [
				@currentRegion?.body
			].join ' '
		}


	methods:
		handleDestroy: ->
			@$el.remove()

